import React from "react";
import { Button, Table } from "react-bootstrap";
import moment from "moment";

export default function ViewLessonStatusCard({
  activeKey,
  selectedDays,
  selectedLocation,
  filteredAPIDateStudentResults,
  dataDirty,
  statusAlerts,
  locationSelector,
  noDateSelectedPrompt,
  onSetActiveKey,
  onRefreshStatus,
  onLessonModalChange,
}) {
  return (
    <div>
      {activeKey === "viewLessonStatus" ? (
        <div>{statusAlerts}</div>
      ) : null}

      {selectedDays.length > 0 ? (
        <div>
          {selectedLocation.length === 0 ? (
            <div>
              You have not selected a road test location. Please select a
              location first!
              <div className="padLeft">
                {selectedLocation.length > 0 ? (
                  <div>
                    Now viewing lessons for: {selectedLocation}
                  </div>
                ) : null}
                {locationSelector}
              </div>
            </div>
          ) : (
            <div>
              {filteredAPIDateStudentResults.length === 0 ? (
                <div>
                  <div>
                    No students found. Please select a new day, or add some
                    students.
                  </div>
                  <br></br>
                  <Button
                    variant="primary"
                    onClick={() => onSetActiveKey("selectDays")}
                  >
                    Select New Day Range
                  </Button>
                  <Button
                    variant="primary"
                    onClick={() => onSetActiveKey("manageStudents")}
                  >
                    Add Some Students
                  </Button>
                  <br></br>
                </div>
              ) : (
                <div>
                  <Button
                    className="rightBut"
                    disabled={dataDirty}
                    onClick={() => onRefreshStatus(activeKey)}
                  >
                    {" "}
                    Refresh Status{" "}
                  </Button>
                  <br></br>
                  <br></br>
                  {!dataDirty ? (
                    <Table striped bordered hover size="sm">
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th>Package</th>
                          <th>Lessons Scheduled</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredAPIDateStudentResults.map((x, index) => {
                          return (
                            <tr key={x.timestamp}>
                              <td>{x.fName + " " + x.lName}</td>
                              <td>
                                {x.selectedPackage}
                                {x.fullPricing
                                  .filter((x) =>
                                    x.name.includes("Extra Lesson"),
                                  )
                                  .map((x) => x.name)
                                  .map((name) => {
                                    return <div key={name}>{name}</div>;
                                  })}
                              </td>
                              <td>
                                {x.selectedPackage.includes("Lesson") ||
                                (x.hasOwnProperty("scheduledLessons") &&
                                  x.scheduledLessons.length > 0) ? (
                                  <div>
                                    {x.skipStudentLessons ? (
                                      "N/A"
                                    ) : (
                                      <div>
                                        {x.scheduledLessons &&
                                        x.scheduledLessons.length > 0 ? (
                                          <div>
                                            {x.scheduledLessons.map(
                                              (lesson) => {
                                                return (
                                                  <div
                                                    key={
                                                      lesson.date +
                                                      lesson.slotName
                                                    }
                                                  >
                                                    {moment(
                                                      lesson.date,
                                                    ).format("MM/DD/YYYY") +
                                                      " at " +
                                                      lesson.slotName +
                                                      " in " +
                                                      lesson.location +
                                                      " with " +
                                                      lesson.instructor}
                                                  </div>
                                                );
                                              },
                                            )}
                                          </div>
                                        ) : (
                                          "No Lessons Scheduled "
                                        )}
                                      </div>
                                    )}
                                  </div>
                                ) : (
                                  "N/A"
                                )}
                              </td>

                              <td>
                                <Button
                                  variant={
                                    x.confirmScheduledRegular === true
                                      ? "success"
                                      : "primary"
                                  }
                                  onClick={() =>
                                    onLessonModalChange(true, index)
                                  }
                                  size="sm"
                                >
                                  Manage Lessons
                                </Button>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </Table>
                  ) : null}
                </div>
              )}
            </div>
          )}
        </div>
      ) : (
        noDateSelectedPrompt
      )}
    </div>
  );
}
